import contactReducer from "./ContactUs/reducer";
import createBotReducer from "./createBot/reducer";
import storeBotsReducer from "./storeBot/reducer";
import authReducer from "./auth/reducer";
import globalSearchReducer from "./globalSearch/reducer";
import submitAnIdeaReducer from "./submitAnIdea/reducer"
import sessionReducer from "./global/reducer"
import { combineReducers } from "redux";
import productStorereducer from "./products/reducer";

const rootReducer = combineReducers({
  contact: contactReducer,
  createBot: createBotReducer,
  storeBot: storeBotsReducer,
  storeProduct: productStorereducer, 
  auth: authReducer,
  search: globalSearchReducer,
  submitAnIdea: submitAnIdeaReducer,
  session:sessionReducer
});

export default rootReducer;
